module.exports = __webpack_public_path__ + "static/media/recipe.ee81f901.png";